import script from "./PenddingCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./PenddingCalendar.vue?vue&type=script&setup=true&lang=js"

import "./PenddingCalendar.vue?vue&type=style&index=0&id=39f53dd4&lang=scss"

const __exports__ = script;

export default __exports__